import {makeAutoObservable} from "mobx";
import {displayErrorDialogPrompt} from "../common/util/errror/log.util";
import axios from "axios";
import fileDownload from "js-file-download";

export const USER_TYPE = {
    Admin: 'Admin',
    LocaleAdmin: 'LocaleAdmin',
    GroupAdmin: 'GroupAdmin',
    Normal: 'Normal',
};

const EmptyLocaleAdmin = {
    id: '',
    password: '',
    localeCode: ' ',
    email: '',
};

const EmptyGroupUser = {
    id: '',
    password: '',
    localeCode: ' ',
    localeAdminUserId: ' ',
    localeGroupType: ' ',
    localeGroupId: ' ',
    isLeader: false,
    email: '',
    name: '',
};

const logPrefix  = "[UserStore]"
export default class UserStore {

    constructor(props) {
        this.userRepository = props.userRepository;
        this.dialogStore = props.dialogStore;
        this.commonStore = props.commonStore;

        this.selectedTab = '';
        this.localeAdminUserCount = 0;
        this.localeAdminUserList = [];
        this.groupAdminUserCount = 0;
        this.groupAdminUserList = [];
        this.normalUserCount = 0;
        this.normalUserList = [];

        this.searchType = 'all';
        this.searchText = '';
        this.tempSearchType = 'all';
        this.tempSearchText = '';
        this.sortColumn = '';
        this.isSortAscending = true;
        this.rowsPerPage = 10;
        this.page = 0;

        this.popoverState = false;

        this.addUserDialogOpen = false;
        this.addUserDialogType = '';

        this.duplicateIdState = 'None';
        this.newLocaleAdmin = Object.assign({}, EmptyLocaleAdmin);
        this.newGroupUser = Object.assign({}, EmptyGroupUser);
        this.newGroupUserFirstId = '';
        this.newGroupUserSecondId = '';

        this.localeAdminUserIdList = [];
        this.localeGroupList = [];
        this.localeGroupConfigList = [];

        this.userDetail = {};
        this.modifyUser = {};
        this.modifyUserDialogOpen = false;

        this.uploadDetail = {};
        this.uploadDetailDialogOpen = false;
        this.uploadUserList = [];

        this.userProfile = {};

        makeAutoObservable(this);
    }

    openErrorDialog = (info) => {
        if (this?.dialogStore) {
            this.dialogStore.openErrorDialog(info)
        }
    }

    getUsers = (userId, isSearch) => {
        if (isSearch) {
            this.page = 0;
            this.sortColumn = '';
        }
        switch (this.selectedTab) {
            case 'LocaleAdmin':
                this.getLocaleAdminUsers();
                break;
            case 'GroupAdmin':
                this.getGroupAdminUsers(userId);
                break;
            case 'Normal':
                this.getNormalUsers(userId);
                break;
            default:
                break;
        }
    }

    setSelectedTab = (tab) => {
        this.selectedTab = tab;
        this.clearSearchData();
    }

    setSearchType = (type) => {
        this.searchType = type;
        this.tempSearchType = type;
        if (type === 'state' || type === 'localeCode' || type === 'groupType') {
            this.searchText = 'all';
            this.tempSearchText = 'all';
        } else {
            this.searchText = '';
            this.tempSearchText = '';
        }
    }

    setTempSearchType = (type) => {
        this.tempSearchType = type;
        if (type === 'state' || type === 'localeCode' || type === 'groupType') {
            this.tempSearchText = 'all';
        } else {
            this.tempSearchText = '';
        }
    }

    setSearchText = (text) => {
        this.searchText = text;
        this.tempSearchText = text;
    }

    setTempSearchText = (text) => {
        this.tempSearchText = text;
    }

    setSearchValue = () => {
        this.searchType = this.tempSearchType;
        this.searchText = this.tempSearchText;
    }

    setSortColumn = (column) => {
        this.sortColumn = column;
    }

    setIsSortAscending = (isAscending) => {
        this.isSortAscending = isAscending;
    }

    setRowsPerPage = (userId, rowsPerPage) => {
        this.rowsPerPage = rowsPerPage;
        this.getUsers(userId);
    }

    setPage = (userId, page) => {
        this.page = page;
        this.getUsers(userId);
    }

    clearSearchData = () => {
        this.searchType = 'all';
        this.searchText = '';
        this.tempSearchType = 'all';
        this.tempSearchText = '';
        this.sortColumn = '';
        this.isSortAscending = true;
        this.page = 0;
    }

    setPopoverState = (boolean) => {
        if (this.popoverState !== null) {
            this.popoverState = boolean;
        }
    }

    setAddUserDialogOpen = (open) => {
        this.addUserDialogOpen = open;
        this.initAddUserForm();
    }

    setModifyUserDialogOpen = (open) => {
        this.modifyUserDialogOpen = open;
    }

    setModifyUser = (user) => {
        this.modifyUser = user;
    }

    setUserProfile = (profile) => {
        this.userProfile = profile;
    }


    initAddUserForm = (userType) => {
        this.newLocaleAdmin = Object.assign({}, EmptyLocaleAdmin);
        this.newGroupUser = Object.assign({}, EmptyGroupUser);

        this.duplicateIdState = 'None'

        this.newGroupUserFirstId = '';
        this.newGroupUserSecondId = '';

        if (userType === USER_TYPE.Admin) {
            this.localeAdminUserIdList = [];
            this.localeGroupList = [];
            this.localeGroupConfigList = [];
        }
    }

    setNewGroupUserFirstId = (id) => {
        this.newGroupUserFirstId = id;
        this.newGroupUser.id = this.newGroupUserFirstId + '@' + this.newGroupUserSecondId;
        this.duplicateIdState = 'None';
    }

    setNewGroupUserSecondId = (id) => {
        this.newGroupUserSecondId = id;
        this.newGroupUser.id = this.newGroupUserFirstId + '@' + this.newGroupUserSecondId;
        this.duplicateIdState = 'None';
    }

    setAddUserDialogType = (type, userType) => {
        this.addUserDialogType = type;
        this.initAddUserForm(userType);
    }

    setNewLocaleAdmin = (localeAdmin) => {
        this.newLocaleAdmin = localeAdmin;
    }

    setNewGroupUser = (groupUser) => {
        this.newGroupUser = groupUser;
    }


    setDuplicateIdState = (state) => {
        this.duplicateIdState = state;
    }

    isCompleteNewLocaleAdminForm = () => {
        return !(this.newLocaleAdmin.id === '' || this.newLocaleAdmin.password === '' || this.newLocaleAdmin.localeCode === ' ');
    }

    isCompleteNewGroupUserForm = () => {
        if (this.newGroupUser.id === '') {
            return false;
        }
        if (this.newGroupUser.password === '') {
            return false;
        }
        if (this.newGroupUser.localeGroupId === ' ') {
            return false;
        }
        if (this.newGroupUser.name === '' && this.addUserDialogType === 'Normal') {
            return false;
        }
        return true;
    }

    getGroupTypeList = () => {
        return this.localeGroupList.map(group => group.groupType).filter((group, index) => {
            return this.localeGroupList.map(group => group.groupType).indexOf(group) === index;
        });
    }

    getGroupList = (groupType) => {
        return this.localeGroupList.filter(group => group.groupType === groupType);
    }

    setLocaleAdminUserIdList = (list) => {
        this.localeAdminUserIdList = list;
    }

    setLocaleGroupList = (list) => {
        this.localeGroupList = list;
    }

    canModify = () => {
        switch (this.selectedTab) {
            case 'GroupAdmin':
                return this.modifyUser.localeGroupId !== ' ';
            case 'Normal':
                return this.modifyUser.localeGroupId !== ' ' && this.modifyUser.name !== '';
            default:
                return true;
        }
    }

    isChangeUser = () => {
        return JSON.stringify(this.userDetail) !== JSON.stringify(this.modifyUser);
    }

    setUploadUserList = (list) => {
        this.uploadUserList = list;
    }

    setUploadDetailDialogOpen = (open) => {
        this.uploadDetailDialogOpen = open;
    }

    setUploadDetail = (detail) => {
        this.uploadDetail = detail;
    }

    initUploadDetail = (userType, localeAdminUserId) => {
        this.uploadDetail = {localeGroupType: ' ', localeGroupId: ' '}
        if (userType === USER_TYPE.Admin) {
            this.uploadDetail.localeCode = ' ';
            this.uploadDetail.localeAdminUserId = ' ';
            this.uploadDetailDialogOpen = true;
        } else {
            this.getLocaleGroupList(localeAdminUserId, () => this.setUploadDetailDialogOpen(true));
        }
    }

    openFileExplorer = () => {
        const input = document.getElementById('memberUpload');
        input.click();
    }

    * getLocaleAdminUsers(callback) {
        this.commonStore.setLoadingState();
        try {
            console.log(logPrefix, 'Start getLocaleAdminUsers.');
            const url = `local-admins?searchType=${this.searchType}&searchText=${this.searchText}&rows-per-page=${this.rowsPerPage}&page=${this.page + 1}&sortColumn=${this.sortColumn}&isAscending=${this.isSortAscending}`;
            const response = yield this.userRepository.getUsers(url);
            this.localeAdminUserCount = response.data.totalCount;
            this.localeAdminUserList = response.data.userList;

            console.log(logPrefix, 'Finished getLocaleAdminUsers.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed getLocaleAdminUsers.');
            this.openErrorDialog({
                titleText: '회원 목록 불러오기 오류',
                text: displayErrorDialogPrompt(e, '회원 목록을 불러오는 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * getGroupAdminUsers(userId, callback) {
        this.commonStore.setLoadingState();
        try {
            console.log(logPrefix, 'Start getGroupAdminUsers.');
            const url = `group-admins?userId=${userId}&searchType=${this.searchType}&searchText=${this.searchText}&rows-per-page=${this.rowsPerPage}&page=${this.page + 1}&sortColumn=${this.sortColumn}&isAscending=${this.isSortAscending}`;
            const response = yield this.userRepository.getUsers(url);
            this.groupAdminUserCount = response.data.totalCount;
            this.groupAdminUserList = response.data.userList;

            console.log(logPrefix, 'Finished getGroupAdminUsers.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed getGroupAdminUsers.');
            this.openErrorDialog({
                titleText: '회원 목록 불러오기 오류',
                text: displayErrorDialogPrompt(e, '회원 목록을 불러오는 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * getNormalUsers(userId, callback) {
        this.commonStore.setLoadingState();
        try {
            console.log(logPrefix, 'Start getNormalUsers.');
            const url = `normal-users?userId=${userId}&searchType=${this.searchType}&searchText=${this.searchText}&rows-per-page=${this.rowsPerPage}&page=${this.page + 1}&sortColumn=${this.sortColumn}&isAscending=${this.isSortAscending}`;
            const response = yield this.userRepository.getUsers(url);
            this.normalUserCount = response.data.totalCount;
            this.normalUserList = response.data.userList;


            console.log(logPrefix, 'Finished getNormalUsers.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed getNormalUsers.');
            this.openErrorDialog({
                titleText: '회원 목록 불러오기 오류',
                text: displayErrorDialogPrompt(e, '회원 목록을 불러오는 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * checkIdDuplicate(id) {
        try {
            console.log(logPrefix, 'Start checkIdDuplicate.');
            const response = yield this.userRepository.checkUserId(id);

            if (response.data) {
                this.duplicateIdState = 'Success';
            } else {
                this.duplicateIdState = 'Fail';
            }

            console.log(logPrefix, 'Finished checkIdDuplicate.');
        } catch (e) {
            console.log(logPrefix, 'Failed checkIdDuplicate. error: ' + e);
        }
    }

    * addLocaleAdminUser(userId) {
        try {
            console.log(logPrefix, 'Start addLocaleAdminUser.');
            const url = `locale-admin`;
            yield this.userRepository.addUser(url, this.newLocaleAdmin);
            this.addUserDialogOpen = false;
            this.getUsers(userId);

            console.log(logPrefix, 'Finished addLocaleAdminUser.');
        } catch (e) {
            console.log(logPrefix, 'Failed addLocaleAdminUser.');
            this.openErrorDialog({
                titleText: '계정 생성 오류',
                text: displayErrorDialogPrompt(e, '계정 생성에 실패하였습니다.')
            });
        }
    }

    * addGroupUser(intl, userId) {
        try {
            console.log(logPrefix, 'Start addGroupUser.');
            const url = `group-user`;
            if (this.addUserDialogType === 'GroupAdmin') {
                this.newGroupUser.isLeader = true;
            }
            yield this.userRepository.addUser(url, this.newGroupUser);
            this.addUserDialogOpen = false;
            this.getUsers(userId);

            console.log(logPrefix, 'Finished addGroupUser.');
        } catch (e) {
            console.log(logPrefix, 'Failed addGroupUser.');
            const errorCode = e.response.data.errorCode;

            let errorText = '계정 생성에 실패하였습니다.';
            if (errorCode === 'ExceedAllowedUser') {
                errorText = intl.formatMessage({id: errorCode});
            }

            this.openErrorDialog({
                titleText: '계정 생성 오류',
                text: errorText
            });
        }
    }

    * getUserProfile(userId) {
        this.userProfile = {};
        try {
            console.log(logPrefix, 'Start getUserProfile.');
            const response = yield this.userRepository.getUserProfile(userId);
            this.userProfile = response.data;
            if (this.userProfile.name === null) {
                this.userProfile.name = '';
            }
            if (this.userProfile.email === null) {
                this.userProfile.email = '';
            }
            this.userProfile.newPassword = '';
            this.userProfile.confirmPassword = '';

            console.log(logPrefix, 'Finished getUserProfile.');
        } catch (e) {
            console.log(logPrefix, 'Failed getUserProfile.');
            this.openErrorDialog({
                titleText: '회원 정보 불러오기 오류',
                text: displayErrorDialogPrompt(e, '회원 정보를 불러오는 도중 에러가 발생했습니다.')
            });
        }
    }

    * updateUserProfile(intl, userId, callback) {
        try {
            console.log(logPrefix, 'Start updateUserProfile.');

            if (this.userProfile.name === '') {
                this.userProfile.name = null;
            }
            if (this.userProfile.email === '') {
                this.userProfile.email = null;
            }

            yield this.userRepository.updateUserProfile(userId, this.userProfile);
            this.getUserProfile(userId);

            console.log(logPrefix, 'Finished updateUserProfile.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed updateUserProfile.');

            const errorCode = e.response.data.errorCode;
            let errorText = '계정 정보 수정에 실패하였습니다.';

            if (errorCode === 'PasswordNotCorrect') {
                errorText = intl.formatMessage({id: errorCode});
            }

            this.openErrorDialog({
                titleText: '계정 정보 수정 오류',
                text: errorText
            });
        }
    }

    * getLocaleAdminUserIdList(localeCode, callback) {
        this.localeAdminUserIdList = [];
        try {
            console.log(logPrefix, 'Start getLocaleAdminUserIdList.');
            const response = yield this.userRepository.getLocaleAdminUserIds(localeCode);

            this.localeAdminUserIdList = response.data;
            this.localeGroupList = [];

            console.log(logPrefix, 'Finished getLocaleAdminUserIdList.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed getLocaleAdminUserIdList. error: ' + e);
        }
    }

    * getLocaleGroupList(localeAdminUserId, callback) {
        this.localeGroupList = [];
        try {
            console.log(logPrefix, 'Start getLocaleGroupList.');
            const response = yield this.userRepository.getLocaleGroups(localeAdminUserId);

            this.localeGroupList = response.data;

            console.log(logPrefix, 'Finished getLocaleGroupList.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed getLocaleGroupList. error: ' + e);
        }
    }

    * getLocaleGroup(groupAdminUserId, callback) {
        this.newGroupUser.localeGroupId = ' ';
        try {
            console.log(logPrefix, 'Start getLocaleGroup.');
            const response = yield this.userRepository.getLocaleGroup(groupAdminUserId);

            this.newGroupUser.localeGroupId = response.data.id;

            console.log(logPrefix, 'Finished getLocaleGroup.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed getLocaleGroup. error: ' + e);
        }
    }

    * getGroupConfigs(localeGroupId, callback) {
        this.localeGroupConfigList = [];
        try {
            console.log(logPrefix, 'Start getGroupConfigs.');
            const response = yield this.userRepository.getLocaleGroupConfigs(localeGroupId);

            this.localeGroupConfigList = response.data;

            console.log(logPrefix, 'Finished getGroupConfigs.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed getGroupConfigs. error: ' + e);
        }
    }

    * getUser(userId, callback) {
        this.userDetail = {};
        this.modifyUser = {};
        try {
            console.log(logPrefix, 'Start getUser.');
            const response = yield this.userRepository.getUser(userId);
            this.userDetail = response.data;
            if (this.userDetail.name === null) {
                this.userDetail.name = '';
            }
            if (this.userDetail.email === null) {
                this.userDetail.email = '';
            }
            if (this.userDetail.localeCode === null) {
                this.userDetail.localeCode = ' ';
            }
            if (this.userDetail.localeAdminUserId === null) {
                this.userDetail.localeAdminUserId = ' ';
            }
            if (this.userDetail.localeGroupType === null) {
                this.userDetail.localeGroupType = ' ';
            }
            if (this.userDetail.localeGroupName === null) {
                this.userDetail.localeGroupName = ' ';
            }
            if (this.userDetail.localeGroupId === null) {
                this.userDetail.localeGroupId = ' ';
            }


            this.modifyUser = JSON.parse(JSON.stringify(this.userDetail));
            if (this.selectedTab !== 'LocaleAdmin' && this.userDetail.localeCode !== ' ') {
                callback && callback(this.userDetail.localeCode, this.userDetail.localeAdminUserId);
            } else {
                this.modifyUserDialogOpen = true;
            }

            console.log(logPrefix, 'Finished getUser.');
        } catch (e) {
            console.log(logPrefix, 'Failed getUser.');
            this.openErrorDialog({
                titleText: '회원 정보 불러오기 오류',
                text: displayErrorDialogPrompt(e, '회원 정보를 불러오는 도중 에러가 발생했습니다.')
            });
        }
    }

    * updateUserDetail(userId, callback) {
        try {
            console.log(logPrefix, 'Start updateUserDetail.');

            if (this.modifyUser.name === '') {
                this.modifyUser.name = null;
            }
            if (this.modifyUser.email === '') {
                this.modifyUser.email = null;
            }
            if (this.modifyUser.localeGroupId === ' ') {
                this.modifyUser.localeGroupId = null;
            }

            yield this.userRepository.updateUser(userId, this.modifyUser);

            console.log(logPrefix, 'Finished updateUserDetail.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed updateUserDetail.');
            this.openErrorDialog({
                titleText: '계정 정보 수정 오류',
                text: displayErrorDialogPrompt(e, '계정 정보 수정에 실패하였습니다.')
            });
        }
    }

    * downloadUserUploadForm() {
        try {
            console.log(logPrefix, 'Start downloadUserUploadForm.');
            const result =  yield axios.get(`/api/v1/user/file/upload-form`, {
                headers: { 'Content-Type': 'application/vnd.ms-excel' },
                responseType: 'arraybuffer',
            });
            const file = result.data;
            const fileName = 'UserUploadForm.xlsx';
            fileDownload( file, fileName );

            console.log(logPrefix, 'Finished downloadUserUploadForm.');
        } catch (e) {
            console.log(logPrefix, 'Failed downloadUserUploadForm. error: ' + e);
        }
    }

    * uploadFile(intl, userId, callback) {
        this.commonStore.setLoadingState('파일을 업로드 하는 중입니다.');
        try {
            console.log(logPrefix, 'Start uploadFile.');

            const url = `group-user/upload`;
            yield this.userRepository.addUsers(url, this.uploadUserList);
            this.getUsers(userId);

            console.log(logPrefix, 'Finished uploadFile.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed uploadFile.');
            const errorCode = e.response.data.errorCode;
            const errorMsg = e.response.data.message;
            let errorText = '계정 생성에 실패하였습니다.';

            if (errorCode === 'CanNotFoundGroupPassword' || errorCode === 'AlreadyExistsUser' || errorCode === 'ExceedAllowedUser') {
                errorText = intl.formatMessage({id: errorCode});
            }
            if (errorCode === 'AlreadyExistsUser') {
                errorText = errorText + '\n';
                for (const existUser of errorMsg.replace('[', '').replace(']','').split(':')[1].split(',')) {
                    errorText = errorText + '\n' + existUser;
                }
            }

            this.openErrorDialog({
                titleText: '계정 생성 오류',
                text: errorText
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }
}

